/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  "'Goals.CreateGoal.footer.create-label": '建立',
  'Goals.CreateGoal.EditMetric.header': '編輯指標',
  'Goals.CreateGoal.create.error': '無法建立目標',
  'Goals.CreateGoal.create.network.error': '連線失敗',
  'Goals.CreateGoal.create.permission.error': '您沒有建立目標所需的權限。',
  'Goals.CreateGoal.error.description': '發生錯誤，請檢查您的網際網路連線並再試一次。',
  'Goals.CreateGoal.error.header': '無法建立目標',
  'Goals.CreateGoal.footer.cancel-label': '取消',
  'Goals.CreateGoal.form.icon.back-button-label': '返回',
  'Goals.CreateGoal.form.name.error': '你必須提供目標名稱',
  'Goals.CreateGoal.form.name.label': '名稱',
  'Goals.CreateGoal.form.owner.error': '負責人不能空白。',
  'Goals.CreateGoal.header': '建立目標',
  'Goals.CreateGoal.parent-goal-label': '父系目標',
  'Goals.CreateGoal.parent-goal.error': '父系目標不能空白。',
  'Goals.CreateGoal.required-fields-are-marked': '必填欄位標有星號 <asterisk></asterisk>',
  'Goals.CreateGoal.site-label': '網站',
  'Goals.CreateGoal.type-label': '類型',
  'Goals.CreateGoal.type-label-placeholder': '要取什麼名稱？',
  'Goals.CreateMetric.add-metric-button': '新增指標',
  'Goals.CreateMetric.metric-select.create-new': '建立新指標',
  'Goals.CreateMetric.metric-select.use-existing': '使用現有指標',
  'Goals.CreateMetric.metric-start-value.label': '開始值',
  'Goals.CreateMetric.metric-target-value.label': '目標值',
  'Goals.CreateMetric.metric-unit-select.label': '單位',
  'Goals.GoalCreationModal.label.date-selection-placeholder': '選取日期',
  'Goals.GoalCreationModal.label.date-selection-title': '目標日期',
  'Goals.GoalCreationModal.label.owner-picker-placeholder': '輸入人員',
  'Goals.GoalCreationModal.label.owner-selection-title': '負責人',
  'townsquare.api.goal-type-description.goal': '任何目標',
  'townsquare.api.goal-type-description.key-result': '衡量目的的量性方法 (目標與關鍵成果 (OKR) 架構)。',
  'townsquare.api.goal-type-description.objective': '您想要實現的結果 (目標與關鍵成果 (OKR) 架構)。',
};
